module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAJZJREFUOE/t0jEOQUEUheHvxRJ0apuQaLQaSo0FSN4GRCvRqexApRGVFRCbUKstQSYZiQxjiteJU8698+eec2+loaqG//0gYIcFrplsulhi8qynGQyxQR+3BNLBBTMcc4DwPsYKPdxjYxsnzHF4Bee2MEWNQWw+Y41tau3bGgNghBb20dpbNKU7CCMHBUsfVQIUD/UP4AGWnBER/j/8QQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ios-arrow-down.png
// module id = 2622
// module chunks = 2